const TEST_HOST = 'http://frame.local';
const APP_HOST = 'https://framemuse.ru:3000';
const CONTAINER_ID = 'calculator';
const TRIGGER_SELECTOR = '.open-calculator';
const UPLOAD_PATH_WEB = 'https://muse.ooo/local/vendor/fileuploader/uploads/';
const DEFAULT_DIGITAL = false;
const DEFAULT_PASPARTU_OVERFLOW = true;
const DEFAULT_OVERLAY = false;
const NO_BAGET_CODE_NAME = 'No';
const NO_BAGET_IMAGE_URL = '/assets/calculator/img/no_baget.webp';
const DEFAULT_VALUE_TITLE = '--------';
const PRICE_OFF = 20;
const FILE_UPLOADER_INPUT_CLASS = 'fileUploader';
const BASE_SIZE_FOR_PREVIEW = 600;
const CLASS_PREFIX = 'calc_';
const UNDER_LAYER = -2;
const MAIN_LAYER = 5;
const BAGET_LAYER = 6;
const CLOSEUP_LAYER = 7;
const OPT_CLASS_HIDDEN = 'hidden';
const OPT_CLASS_OPTION_NORMAL = 'option-normal';
const OPT_CLASS_OPTION_WIDE = 'option-wide';
const BAGET_OVERLAP = 0.5;
const SIZE_STEP = 5;
const SIZE_MIN = 25;
const SIZE_MAX = 120;
const PROJECT_SIZE_MAX = 300;
const DESIRED_PPI = 72;
const DEFAULT_SIZE_WIDTH = 25;
const DEFAULT_SIZE_HEIGHT = 30;
const DEFAULT_PREVIEW_TO_BACKGROUND_RATIO = 4 / 5; //which part of preview background container could be used to render actual preview
const DEFAULT_PICTURE_DIMENSION_RATE = 50; //1-100
const DEFAULT_BACKGROUND = '/assets/calculator.modules/img/background-default.webp';
const DEFAULT_BACKGROUND_LARGE = '/assets/calculator.modules/img/background-default-large.webp';
const PREVIEW_BACKGROUND_HEIGHT = 235; //cm, height of background
const PREVIEW_BACKGROUND_CHANGE_THRESHOLD = 180; //cm, height of project 
const PREVIEW_BACKGROUND_HEIGHT_LARGE = 280; //cm, height of background
const DEFAULT_IMAGE = '/assets/calculator.modules/img/default.jpg';
const MAGNIFICATION = 2;
const PRESERVE_FORMAT = false;
const MOBILE_UNDERLAYER_PREVIEW = false;
//const BASE_SIZE_FOR_PREVIEW = 600;
const MSG_LOW_IMAGE_QUALITY = 'Внимание! Изображение имеет недостаточное разрешение. В напечатанном виде хорошо будет смотреться с расстояния трех шагов.<br/>Вы можете:<br/>- уменьшить размер отпечатка;<br/>- заменить фото или самостоятельно его отредактировать; <br/>- воспользоваться услугами нашего дизайнера или просто посоветоваться с нами.';
const TEXT = {
    link_to_image: 'Поле для ссылки на фото или облако'
};
const DIGITAL_STEPS = [
    'designStyle', 'face', 'image', 'formatCollage'
];
const ROLLED_STEPS = [
    'designStyle', 'face', 'size', 'material', 'underframeThickness', 'design', 'ink', 'image'
];
const ONE_MODULE_PRINT = {
    "formatModuleID": 1,
    "value": [
        {
            "shiftY": "0",
            "shiftX": "-2",
            "height": "100",
            "width": "48",
            "y": "0",
            "x": "2",
            "id": 0
        },
        {
            "shiftY": "0",
            "shiftX": "2",
            "height": "100",
            "width": "48",
            "y": "0",
            "x": "50",
            "id": 1
        }
    ]
};
Object.freeze(ONE_MODULE_PRINT);
export { MSG_LOW_IMAGE_QUALITY, DESIRED_PPI, OPT_CLASS_OPTION_WIDE, OPT_CLASS_OPTION_NORMAL, UNDER_LAYER, MOBILE_UNDERLAYER_PREVIEW, TRIGGER_SELECTOR, DEFAULT_PASPARTU_OVERFLOW, DEFAULT_OVERLAY, PRESERVE_FORMAT, MAGNIFICATION, DEFAULT_DIGITAL, BAGET_LAYER, MAIN_LAYER, CLOSEUP_LAYER, CONTAINER_ID, TEST_HOST, APP_HOST, PRICE_OFF, FILE_UPLOADER_INPUT_CLASS, BASE_SIZE_FOR_PREVIEW, CLASS_PREFIX, OPT_CLASS_HIDDEN, BAGET_OVERLAP, SIZE_STEP, SIZE_MIN, SIZE_MAX, PROJECT_SIZE_MAX, DEFAULT_SIZE_WIDTH, DEFAULT_SIZE_HEIGHT, DEFAULT_PREVIEW_TO_BACKGROUND_RATIO, DEFAULT_PICTURE_DIMENSION_RATE, PREVIEW_BACKGROUND_HEIGHT, PREVIEW_BACKGROUND_HEIGHT_LARGE, PREVIEW_BACKGROUND_CHANGE_THRESHOLD, DEFAULT_IMAGE, DEFAULT_BACKGROUND, DEFAULT_BACKGROUND_LARGE, TEXT, DIGITAL_STEPS, ROLLED_STEPS, UPLOAD_PATH_WEB, DEFAULT_VALUE_TITLE, NO_BAGET_CODE_NAME, NO_BAGET_IMAGE_URL, ONE_MODULE_PRINT };
